import Fuse from "fuse.js";
import type { Category, Shop } from "../types";

export function createShopSearch(shops: Shop[], categories: Category[]): Fuse<Shop> {
  const categoryById = new Map(categories.map((category) => [category.id, category.name]));

  return new Fuse(shops, {
    includeScore: true,
    threshold: 0.34,
    keys: [
      { name: "name", weight: 0.4 },
      { name: "aliases", weight: 0.2 },
      { name: "tags", weight: 0.16 },
      { name: "cuisineTypes", weight: 0.12 },
      { name: "locationCode", weight: 0.08 },
      {
        name: "categoryIds",
        weight: 0.04,
        getFn: (shop) => shop.categoryIds.map((id) => categoryById.get(id) ?? id)
      }
    ]
  });
}

export function searchShops(searcher: Fuse<Shop>, shops: Shop[], query: string): Shop[] {
  const trimmed = query.trim();
  if (!trimmed) {
    return [...shops].sort((a, b) => a.name.localeCompare(b.name));
  }
  return searcher.search(trimmed).map((result) => result.item);
}

export function filterByCategory(shops: Shop[], categoryId: string | null): Shop[] {
  if (!categoryId) return shops;
  return shops.filter((shop) => shop.categoryIds.includes(categoryId));
}

